var map = {
	"./meitavlp/assets/static/core/images/index.html": 98613,
	"./meitavlp/assets/static/core/images/logos/main.png": 65831,
	"./meitavlp/assets/static/core/images/logos/main.svg": 80153,
	"./meitavlp/assets/static/core/images/meta/defaultOgImage.png": 54393,
	"./meitavlp/assets/static/core/index.html": 56766,
	"./meitavlp/assets/static/core/nav/adminSideNavFactory": 8816,
	"./meitavlp/assets/static/core/nav/adminSideNavFactory.js": 8816,
	"./meitavlp/assets/static/dev/meitav-trade-logo.webp": 58812,
	"./meitavlp/assets/static/icons/rubicons/meitav-contact-form-phone.svg": 40278,
	"./meitavlp/assets/static/icons/rubicons/meitav-whatsapp.svg": 14716,
	"./meitavlp/assets/static/images/index.html": 12359,
	"./meitavlp/assets/static/images/lp/sections/video1/shadow.png": 34814,
	"./meitavlp/assets/static/images/section-preview/Advantages1.png": 48649,
	"./meitavlp/assets/static/images/section-preview/App1.png": 87878,
	"./meitavlp/assets/static/images/section-preview/EmbeddedForm1.png": 13023,
	"./meitavlp/assets/static/images/section-preview/Features1.png": 57672,
	"./meitavlp/assets/static/images/section-preview/GraphComparison1.png": 47636,
	"./meitavlp/assets/static/images/section-preview/Header1.png": 24514,
	"./meitavlp/assets/static/images/section-preview/Hero1.png": 14603,
	"./meitavlp/assets/static/images/section-preview/Leads1.png": 78966,
	"./meitavlp/assets/static/images/section-preview/Legal1.png": 59688,
	"./meitavlp/assets/static/images/section-preview/LpIndex1.png": 9445,
	"./meitavlp/assets/static/images/section-preview/NumberOne1.png": 46774,
	"./meitavlp/assets/static/images/section-preview/Portfolio1.png": 2585,
	"./meitavlp/assets/static/images/section-preview/Qna1.png": 2383,
	"./meitavlp/assets/static/images/section-preview/Quote1.png": 83205,
	"./meitavlp/assets/static/images/section-preview/Reasons1.png": 79596,
	"./meitavlp/assets/static/images/section-preview/SlimCta1.png": 76412,
	"./meitavlp/assets/static/images/section-preview/SlimCta2.png": 34519,
	"./meitavlp/assets/static/images/section-preview/Steps1.png": 17646,
	"./meitavlp/assets/static/images/section-preview/Ticker1.png": 20833,
	"./meitavlp/assets/static/images/section-preview/Ttf1.png": 76683,
	"./meitavlp/assets/static/images/section-preview/Video1.png": 32422,
	"./meitavlp/assets/static/images/section-preview/VideoAdvantages1.png": 73244,
	"./meitavlp/assets/static/images/section-preview/ttf2png.png": 87227,
	"./meitavlp/assets/static/images/surprise-stock/finger-icon.svg": 71191,
	"./meitavlp/assets/static/images/surprise-stock/meitav-trade-logo.webp": 62696,
	"./meitavlp/assets/static/images/surprise-stock/scratch-card-done.svg": 67354,
	"./meitavlp/assets/static/images/surprise-stock/scratch-card-empty-bg.svg": 80159,
	"./meitavlp/assets/static/images/surprise-stock/scratch-card-full.svg": 11437,
	"./meitavlp/assets/static/scripts/nagish": 18260,
	"./meitavlp/assets/static/scripts/nagish.js": 18260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19647;